import React, { useEffect, useState } from 'react';
import Skeleton from '@mui/material/Skeleton';

let cachedMonths = null;
let monthsPromise = null;

const GetMonthsOpt = ({ input_id, onLoadingChange, onChange }) => {
    const [options, setOptions] = useState(cachedMonths || '');
    const [loading, setLoading] = useState(!cachedMonths);

    useEffect(() => {
        if (cachedMonths) {
            if (onLoadingChange) onLoadingChange(false);
            return;
        }

        const fetchMonths = async () => {
            try {
                if (!monthsPromise) {
                    monthsPromise = fetch(`${process.env.REACT_APP_URL_HEADER}/Common/putMonths`)
                        .then(res => res.text());
                }
                const data = await monthsPromise;
                
                cachedMonths = data;
                setOptions(data);
                setLoading(false);
                if (onLoadingChange) onLoadingChange(false);
            } catch (error) {
                console.error("Error fetching months:", error);
                monthsPromise = null; // reset if error
                setLoading(false);
                if (onLoadingChange) onLoadingChange(false);
            }
        };

        fetchMonths();
    }, []);

    return (
        <div>
            {loading ? (
                <Skeleton width={100} height={40} />
            ) : (
                <>
                <select name= { input_id} id= { input_id} dangerouslySetInnerHTML={{ __html: options }} onChange={onChange} />
                 </>
           )}
        </div>
    );
};

const getSelectMonth = ({ input_id , onLoadingChange }) => {
    return (
        <>
            <GetMonthsOpt input_id= {input_id} onLoadingChange={onLoadingChange} />
        </>
    );
}

export default getSelectMonth;
